var _defs, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPostItInterfaces(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".g{fill:url(#d);}.h{fill:url(#b);}.i{fill:#ebbabe;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 22.25,
    y1: 717.18,
    x2: 21.76,
    y2: 717.79,
    gradientTransform: "translate(-404.32 14980.71) scale(22.04 -20.78)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cc797e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2c6c9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 42.9,
    y1: 721.27,
    x2: 42.12,
    y2: 722.21,
    gradientTransform: "translate(-4031.81 68759.16) scale(95.83 -95.21)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe2e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#f5d4d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#f2c6c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#f2c6c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2c6c9"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "c",
    className: "h",
    d: "M73.9,89.96l23-21.68h-23v21.68Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "e",
    className: "g",
    d: "M82.43,69.75c-1.75,23.91-18.41,28.3-40.68,28.93-21.64,.62-41.75,.67-41.75,.67V0H99.79s.21,32.61,.21,54.72c0,13.91-2.27,17.1-17.57,15.03Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "f",
    className: "i",
    d: "M0,20.21H99.9l-.11-20.21H0V20.21Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostItInterfaces);
export default __webpack_public_path__ + "static/media/Post-it-interfaces.b63373f3b6a0c14020053ed4ead2bed7.svg";
export { ForwardRef as ReactComponent };